import { FunctionComponent } from 'react'
import { useStyles } from './styles'

const ReservationListSkeleton: FunctionComponent = () => {
  const styles = useStyles()

  return (
    <div css={styles.skeletonWrapper}>
      <strong css={styles.skeletonTitle} />

      <div css={styles.skeletonCardWrapper}>
        <div css={styles.skeletonCard} />
        <div css={styles.skeletonCard} />
        <div css={styles.skeletonCard} />
      </div>
    </div>
  )
}

export { ReservationListSkeleton }
